/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Offer_OpenedInputs */

const en_us2_coach_extra_offer_opened = /** @type {(inputs: Coach_Extra_Offer_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opened`)
};

const pt_br2_coach_extra_offer_opened = /** @type {(inputs: Coach_Extra_Offer_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aberto`)
};

const es_419_coach_extra_offer_opened = /** @type {(inputs: Coach_Extra_Offer_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abierto`)
};

const pt_pt2_coach_extra_offer_opened = /** @type {(inputs: Coach_Extra_Offer_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aberto`)
};

const fr_fr2_coach_extra_offer_opened = /** @type {(inputs: Coach_Extra_Offer_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ouvert`)
};

const de_de2_coach_extra_offer_opened = /** @type {(inputs: Coach_Extra_Offer_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geöffnet`)
};

const it_it2_coach_extra_offer_opened = /** @type {(inputs: Coach_Extra_Offer_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aperto`)
};

/**
* | output |
* | --- |
* | "opened" |
*
* @param {Coach_Extra_Offer_OpenedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_offer_opened = /** @type {((inputs?: Coach_Extra_Offer_OpenedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Offer_OpenedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_offer_opened(inputs)
	if (locale === "es-419") return es_419_coach_extra_offer_opened(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_offer_opened(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_offer_opened(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_offer_opened(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_offer_opened(inputs)
	return en_us2_coach_extra_offer_opened(inputs)
});
export { coach_extra_offer_opened as "coach-extra.offer_opened" }